// import React from "react";
// import Lottie from "react-lottie";
// import "./Success_Lottie.css";
// import * as animationData from "./Success_Lottie.json";

// function Success_Lottie() {
//   const defaultOptions = {
//     loop: true,
//     autoplay: true,
//     animationData: animationData,
//     rendererSettings: {
//       preserveAspectRatio: "xMidYMid slice",
//     },
//   };

//   return (
//     <section className="main">
//       <div className="Success_Lottie_icon">
//         <Lottie className="me-auto" options={defaultOptions} />
//       </div>
//     </section>
//   );
// }
// export default Success_Lottie;

import React from "react";
import Lottie from "lottie-react";
import animationData from "./Success_Lottie.json";
import "./Success_Lottie.css";

function Success_Lottie() {
  if (!animationData) return null;

  return (
    <section className="main">
      <div className="Success_Lottie_icon">
        <Lottie
          animationData={animationData}
          loop={true}
          autoplay={true}
          className="me-auto"
          style={{ width: "100%", height: "100%" }}
        />
      </div>
    </section>
  );
}

export default Success_Lottie;
